import { Link } from "react-router-dom/cjs/react-router-dom";
import NoAuthHeader from "../components/NoAuthHeader";
import { Layout } from "antd";
import { ReactComponent as ExportOutlined } from "../assets/icons/exportOutlined.svg";

const { Content } = Layout;
const NoAuthContainer = ({ children }) => {
  return (
    <>
      <NoAuthHeader />
      <Content className="gray-color" style={{ height: "calc(100% - 13rem)" }}>
        {children}
        <div className="noauth-patent-wrapper">
          <ExportOutlined className="noauth-patent-icon" />
          Patents{" "}
          <a
            href="https://www.dinamicor.com/patents/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#8c8c8c" }}
          >
            www.dinamicor.com/patents/
          </a>
        </div>
      </Content>
    </>
  );
};

export default NoAuthContainer;
